import React from "react";
//#region redux
import { selfInvoiceSaved } from "store/actions/selfInvoiceActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { SelfInvoiceTodoFormContainerProps } from "models/propTypes/selfInvoicePropTypes";
import { InvoiceFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import SelfInvoiceTodoForm from "./todoForm";
import { useInvoiceService, useSelfInvoiceService } from "serviceHooks";
import useSelfInvoiceInitialValues from "./useInitialValues";
import useSelfInvoiceFormValidations from "./useValidationSchema";
//#endregion

const SelfInvoiceTodoFormContainer: React.ForwardRefRenderFunction<FormHandles, SelfInvoiceTodoFormContainerProps> = (
  props,
  ref
) => {
  const { invoice, draftCustomerInvoice } = props;

  const invoiceService = useInvoiceService();
  const selfInvoiceService = useSelfInvoiceService();

  const dispatch = useDispatch();

  const { getTodoInitialValues } = useSelfInvoiceInitialValues(invoice, draftCustomerInvoice);
  const initialValues = getTodoInitialValues();

  const { getTodoValidationSchema } = useSelfInvoiceFormValidations();

  const handleSubmit = async (form: InvoiceFormTypes.SelfInvoiceTodo) => {
    const post: WintSuperkollAPIModel.InvoicePost = selfInvoiceService.convertFormToAPIRequest(form, invoice, true);

    if (!form.isDimensionsAdvancedConfiguration) {
      post.dimensions = form.dimensions?.map((d) => d.dimensionId!);
    }

    const customerInvoiceId = await invoiceService.createOrUpdateInvoice(form.relatedInvoiceId, post);

    if (customerInvoiceId) {
      try {
        await invoiceService.markAsSent(customerInvoiceId);
      } catch (e) {
        dispatch(selfInvoiceSaved({ ...invoice, draftInvoiceId: customerInvoiceId }));
        throw e;
      }
    }
  };

  return (
    <SelfInvoiceTodoForm
      ref={ref}
      defaultValues={initialValues}
      validationSchema={getTodoValidationSchema()}
      handleSubmit={handleSubmit}
      invoice={invoice}
    />
  );
};

export default React.forwardRef(SelfInvoiceTodoFormContainer);
